import React from 'react'
import ProductoItem from '../components/producto_opcion_admin'

const ProductoOpcion = (props) => {
      //const items = props.opcion
      
      if(!props.datos){  
        return "CARGANDO"
      }
      var listaItems = ""
      if(props.datos.hasOwnProperty("items")){
        listaItems = props.datos.items.map((item,i)=>{
          return <ProductoItem key={i} item={item} cat={props.datos.id}/>
        })
      }

		  return (
        <div className="card mb-3" >
          <div className="card-header">
            {props.datos.nombre}
          </div>
          <ul className="list-group list-group-flush">
            {listaItems}
          </ul>
        </div>
		  )
}
export default ProductoOpcion




// WEBPACK FOOTER //
// ./src/components/producto_opciones_admin.js